// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var PasswordResetToken = function (x) {
    return x;
};
var tsBridgePasswordResetToke = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("PasswordResetToken")("__brandPasswordResetToken"));
    }
};
var writePasswordResetToken = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showPasswordResetToken = Data_Show.showString;
var readPasswordResetToken = Simple_JSON.readString;
var ordPasswordResetToken = Data_Ord.ordString;
var newtypePasswordResetToken = {
    Coercible0: function () {
        return undefined;
    }
};
var makePasswordResetToken = PasswordResetToken;
var eqPasswordResetToken = Data_Eq.eqString;
export {
    PasswordResetToken,
    makePasswordResetToken,
    unwrap,
    newtypePasswordResetToken,
    eqPasswordResetToken,
    ordPasswordResetToken,
    showPasswordResetToken,
    readPasswordResetToken,
    writePasswordResetToken,
    tsBridgePasswordResetToke
};
//# sourceMappingURL=index.js.map
